import { getToken } from "./auth/auth-main"

export async function BSGet(url) {
    return await BSFetch(url, {
        method: "GET",
        headers: {
            authorization: getToken(),
            "Content-Type": "application/json"
        },
        mode: "cors",
        cache: "no-cache"
    })
}

export async function BSPost(url, body, contentType="application/json") {
    const params = {
        method: "POST",
        headers: {
            authorization: getToken(),
        },
        body,
        mode: "cors",
        cache: "no-cache"
    }
    if (contentType !== undefined) params.headers["Content-Type"] = contentType
    console.log(params)
    return await BSFetch(url, params)
}

export async function BSPatch(url, body, contentType="application/json") {
    const params = {
        method: "PATCH",
        headers: {
            authorization: getToken(),
        },
        body,
        mode: "cors",
        cache: "no-cache"
    }
    if (contentType !== undefined) params.headers["Content-Type"] = contentType
    console.log(params)
    return await BSFetch(url, params)
}